import {
  ApiConfig,
  Media,
  PaginatedContentType,
  PaginatedMedia,
  PaginatedReferenceFieldOptions
} from '@form-builder/types'

export const fetchReferences = async (
  apiConfig: ApiConfig,
  url?: string,
  params?: string
): Promise<PaginatedReferenceFieldOptions> => {
  try {
    const reqInit: RequestInit = {
      method: 'GET',
      headers: {
        Authorization: `Token ${apiConfig?.tokens?.access}`,
        'Saas-App-Token': apiConfig?.tokens?.saas,
        'Content-Type': 'application/json'
      }
    }

    const fullUrl = `${apiConfig?.baseUrl}${url}?${params}`

    const response = await fetch(fullUrl, reqInit)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    return data
  } catch {
    return {
      count: 0,
      results: [],
      next: null,
      previous: null
    }
  }
}

export const fetchContentTypes = async (
  apiConfig: ApiConfig,
  params?: string
): Promise<PaginatedContentType> => {
  try {
    const reqInit: RequestInit = {
      method: 'GET',
      headers: {
        Authorization: `Token ${apiConfig?.tokens.access}`,
        'Saas-App-Token': apiConfig?.tokens?.saas
      }
    }

    const response = await fetch(
      `${apiConfig?.baseUrl}/content-type/forms-list/?${params}`,
      reqInit
    )

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data: PaginatedContentType = await response.json()

    return data
  } catch {
    return {
      count: 0,
      results: [],
      next: null,
      previous: null
    }
  }
}

export const createMedia = async <T, R = T>(
  apiConfig: ApiConfig,
  data: T
): Promise<R | null> => {
  const headers = {
    Authorization: `Token ${apiConfig?.tokens?.access}`,
    'Saas-App-Token': apiConfig?.tokens?.saas,
    'Content-Type': 'application/json'
  }

  const reqInit: RequestInit = {
    method: 'POST',
    headers,
    body: JSON.stringify(data)
  }

  try {
    const res = await fetch(`${apiConfig.baseUrl}/media/create/`, reqInit)

    if (!res.ok) {
      throw new Error(`Failed to create media. Status: ${res.status}`)
    }

    const response: R = await res.json()

    return response
  } catch {
    return null
  }
}

export const getListMedia = async (
  apiConfig: ApiConfig,
  queryParams: URLSearchParams
): Promise<PaginatedMedia> => {
  const headers = {
    Authorization: `Token ${apiConfig?.tokens?.access}`,
    'Saas-App-Token': apiConfig?.tokens?.saas
  }

  const reqInit: RequestInit = {
    method: 'GET',
    headers
  }

  try {
    const res = await fetch(
      `${apiConfig.baseUrl}/media/list/?${queryParams}`,
      reqInit
    )

    if (!res.ok) {
      throw new Error(`Failed to fetch media list. Status: ${res.status}`)
    }

    const response = await res.json()

    return response
  } catch {
    return {
      count: 0,
      results: [],
      next: null,
      previous: null
    }
  }
}

export const getMediaById = async (
  apiConfig: ApiConfig,
  id: string
): Promise<Media | null> => {
  const headers = {
    Authorization: `Token ${apiConfig?.tokens?.access}`,
    'Saas-App-Token': apiConfig?.tokens?.saas
  }

  const reqInit: RequestInit = {
    method: 'GET',
    headers
  }

  try {
    const res = await fetch(`${apiConfig.baseUrl}/media/get/${id}/`, reqInit)

    if (!res.ok) {
      throw new Error(`Failed to fetch media list. Status: ${res.status}`)
    }

    const response = await res.json()

    return response?.instance
  } catch {
    return null
  }
}
